import React from 'react'
import Button from '../../components/Button/Button'
import styles from './CallToAction.module.scss'

interface Props {
  contents: {
    heading: string[]
  }
}

const CallToAction: React.FC<Props> = ({ contents }) => {
  const headingBr = contents.heading.map((text, index) => (
    <React.Fragment key={index}>
      {text}
      {index < contents.heading.length - 1 && <br />}
    </React.Fragment>
  ))

  return (
    <div className={styles.call_to_action_section}>
      <div className={styles.container}>
        <div className={styles.text}>
          <div className={styles.left}>
            <div className={styles.color_box}></div>
          </div>
          <h2>{headingBr}</h2>
          <div className={styles.right}>
            <div className={styles.color_box}></div>
          </div>
        </div>
        {/* <Button /> */}
      </div>
    </div>
  )
}
export default CallToAction
